module.exports = __webpack_public_path__ + "media/images/smart_phone/login/202001/i_new_customer-000c109e5818934ee5d3b9bfe41142c6.png";